var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWinNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07658 29.3592V23.9532C9.07658 23.5366 8.73522 23.2002 8.31247 23.2002H3.15799C2.51991 23.2002 2 22.6904 2 22.0589V15.4652C2 15.0382 2.35186 14.6914 2.78512 14.6914H7.03632",
    stroke: "#E09234",
    strokeWidth: 3.45,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07658 29.3592V23.9532C9.07658 23.5366 8.73522 23.2002 8.31247 23.2002H3.15799C2.51991 23.2002 2 22.6904 2 22.0589V15.4652C2 15.0382 2.35186 14.6914 2.78512 14.6914H7.03632",
    stroke: "#E09234",
    strokeWidth: 3.45,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9443 8.69141V14.2552C12.9443 14.6848 13.2962 15.0316 13.7321 15.0316H19.0362C19.6953 15.0316 20.2284 15.5569 20.2284 16.2064V22.9943C20.2284 23.4342 19.866 23.7913 19.4196 23.7913H15.0424",
    stroke: "#E09234",
    strokeWidth: 3.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9443 8.69141V14.2552C12.9443 14.6848 13.2962 15.0316 13.7321 15.0316H19.0362C19.6953 15.0316 20.2284 15.5569 20.2284 16.2064V22.9943C20.2284 23.4342 19.866 23.7913 19.4196 23.7913H15.0424",
    stroke: "#E09234",
    strokeWidth: 3.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6136 31.5025C14.825 29.1191 15.19 25.7187 12.677 22.9886C11.5348 21.7464 10.2403 20.7268 8.85123 19.878C5.51382 17.8362 4.18515 14.9404 4.92038 11.3511C5.42979 8.85907 7.8009 6.80692 10.025 6.93114C7.01316 9.75704 6.98165 12.9219 10.0118 15.4502C11.6031 16.7778 13.3755 17.8181 14.9142 19.2233C16.2534 20.4499 17.4797 21.8033 17.5821 24.2255C17.7501 28.1823 15.2766 31.4507 11.6136 31.4999V31.5025Z",
    fill: "url(#paint0_linear_17462_7087)",
    stroke: "#54A39D",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7231 3.74609C11.096 4.64924 11.7997 5.03224 12.766 5.14352C12.12 5.60415 11.6369 6.22264 11.3192 6.99898C10.8176 6.4219 10.1585 5.96386 9.34717 5.62485C10.2872 5.31431 10.71 4.7217 10.7205 3.74609H10.7231Z",
    fill: "url(#paint1_linear_17462_7087)",
    stroke: "#54A39D",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0556 1.92975C12.5436 2.06949 12.0473 2.0255 11.6193 2.63622C11.7296 1.90646 11.4276 1.51052 11.0889 1.05765C11.6665 1.04989 12.2258 1.12752 12.5357 0.496094C12.6328 1.01883 12.4569 1.59074 13.0556 1.92975Z",
    fill: "url(#paint2_linear_17462_7087)",
    stroke: "#54A39D",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2366 0.900529L14.8221 0.613281C14.8221 0.613281 14.8405 0.613281 14.8458 0.618457L15.2265 1.00145C15.279 1.0558 15.2922 1.13602 15.258 1.2033L15.0059 1.67688C15.0059 1.67688 14.9928 1.68981 14.9849 1.68723L14.5937 1.62253C14.4335 1.59665 14.3075 1.46985 14.2838 1.30941L14.2261 0.92382C14.2261 0.92382 14.2261 0.905705 14.2366 0.903117V0.900529Z",
    fill: "url(#paint3_linear_17462_7087)",
    stroke: "#54A39D",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17462_7087",
    x1: 4.72344,
    y1: 19.2129,
    x2: 17.59,
    y2: 19.2129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51C4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#4FAAA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#4E9791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4D8B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4D8883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2C706C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17462_7087",
    x1: 9.34717,
    y1: 5.37125,
    x2: 12.766,
    y2: 5.37125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51C4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#4FAAA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#4E9791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4D8B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4D8883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2C706C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17462_7087",
    x1: 11.0889,
    y1: 1.56486,
    x2: 13.0556,
    y2: 1.56486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51C4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#4FAAA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#4E9791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4D8B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4D8883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2C706C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17462_7087",
    x1: 15.0727,
    y1: 0.841632,
    x2: 14.3976,
    y2: 1.52669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51C4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#4FAAA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#4E9791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4D8B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4D8883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2C706C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinNotification);
export default __webpack_public_path__ + "static/media/WinNotification.5e431e7a88551ac9508d2bf82d2c446a.svg";
export { ForwardRef as ReactComponent };